module.exports = __webpack_public_path__ + "assets/kentico-cms.12128938.svg";